import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatsIncluded() {
  const items = ['Diagnóstico rápido para identificar tu patrón (pico–bajón, cansancio plano, nervio agotado, noches malas)', 'Rutina nocturna realista (mínima y estándar)', 'Café inteligente (sin moralismos)', '“Proteína ancla” + plato RRH para energía estable', 'Protocolo de 90 segundos para cortar el estrés en el momento', 'Movimiento que suma: fuerza mínima viable + zona 2', 'Plan completo de 21 días con checklists y modo rescate', 'Estrategias para vida real: invierno, trabajo, familia, viajes'];
  return <section className="py-24 bg-white text-[#1a1f3a]" data-id="element-239">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-240">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-241">
          <FadeIn data-id="element-242">
            <div className="relative" data-id="element-243">
              <div className="absolute inset-0 bg-[#d4a574] transform rotate-3 rounded-2xl opacity-20" data-id="element-244"></div>
              <img src="https://cdn.magicpatterns.com/uploads/oyf4s7bCwydHgFS9sJ3xLb/GUIA_RAPIDA_ENERGIA.png" alt="Guía digital en tablet" className="relative rounded-2xl shadow-2xl w-full" data-id="element-245" />
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-246">
            <div data-id="element-247">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8" data-id="element-248">
                Qué obtienes dentro de la <br data-id="element-249" />
                <span className="text-[#d4a574]" data-id="element-250">
                  Guía de Reinicio de Energía
                </span>
              </h2>

              <ul className="space-y-4" data-id="element-251">
                {items.map((item, i) => <li key={i} className="flex items-start" data-id="element-252">
                    <CheckCircle2 className="w-6 h-6 text-[#8da399] mr-3 flex-shrink-0 mt-0.5" data-id="element-253" />
                    <span className="text-gray-700 leading-relaxed" data-id="element-254">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}